import { render, staticRenderFns } from "./ContactTagEdit.vue?vue&type=template&id=f08dcffc"
import script from "./ContactTagEdit.vue?vue&type=script&lang=ts"
export * from "./ContactTagEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports